<!-- components/Header.vue -->
<template>
  <header ref="headerRef">
    <div class="menu-icon" @click="goTo('HomePage')">
      <img src="@/assets/header-logo.png" alt="" />
    </div>
    <ul class="headerright">
      <li class="wow animate__fadeInRight btns" data-wow-delay="0.2s"><a href="mailto:Hello@mydigim.com?subject=Hello&body=This is a email."><img src="@/assets/header/menu3.png" /></a></li>
      <li class="wow animate__fadeInRight btns" data-wow-delay="0.3s"><img @click="toggleMenu" src="@/assets/header/menu1.png" /></li>
    </ul>
  </header>
</template>

<script setup>
import { defineEmits, ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const emit = defineEmits(['toggle-menu']);
const headerRef = ref(null);

const toggleMenu = () => {
  emit('toggle-menu');
};
const goTo = (name) => {
  router.push({ name });
};
const handleScroll = () => {
  if (headerRef.value) {
    if (window.scrollY > 0) {
      headerRef.value.classList.add('scrolled');
    } else {
      headerRef.value.classList.remove('scrolled');
    }
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style lang="less" scoped>
header {
  position: fixed;
  /* 固定在顶部 */
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 998;
  /* 确保 header 在其他内容之上 */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: max(1.5vw,15px);
  background-color: transparent;
  color: white;
  box-shadow: none;

  >ul {
    list-style: none;
    margin: 0px !important;
    padding: 0px !important;
  }
}

header.scrolled {
  background-color: #fff;
  box-shadow: 0 15px 35px rgba(50, 50, 93, .1), 0 5px 15px rgba(0, 0, 0, .07) !important;
}

.menu-icon {
  cursor: pointer;
  img{
    width: 5vw;
    min-width: 50px;
  }
}

.headerright {
  display: flex;
  gap: 20px;
  margin-right: 2vw;
  justify-content: center;
  align-items: center;

  img {
    width: 2vw;
    min-width: 20px;
  }
}

.btns {
  cursor: pointer;
}
</style>